module.exports = __webpack_public_path__ + "img/valve-switching.ca67917f.svg";